/* eslint-disable */

import { createContext } from "react";

const CollectionContext = createContext(null);

export default CollectionContext;
